/**
 * Select the least restrictive cross-origin mode that still preserves canvas
 * export when an upload is known to support CORS.
 *
 * First-party upload proxy URLs may redirect to storage without CORS headers.
 * Setting `anonymous` on those URLs prevents otherwise viewable maps from
 * rendering in Konva, so same-origin URLs deliberately use the browser default.
 * date_of_change: 2026-08-18
 */
export const getCanvasImageCrossOriginMode = (source, currentOrigin) => {
  if (typeof source !== 'string' || !source.trim()) return undefined;

  try {
    const baseOrigin = currentOrigin
      || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    const resolvedUrl = new URL(source, baseOrigin);

    if (resolvedUrl.origin === baseOrigin) return undefined;
    if (resolvedUrl.pathname.includes('/uploads/')) return 'anonymous';
  } catch (_) {
    return undefined;
  }

  return undefined;
};

export default getCanvasImageCrossOriginMode;
